import { render } from "./allocateShop.vue?vue&type=template&id=55f157ba&scoped=true"
import script from "./allocateShop.vue?vue&type=script&lang=js"
export * from "./allocateShop.vue?vue&type=script&lang=js"

import "./allocateShop.vue?vue&type=style&index=0&id=55f157ba&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f157ba"]])

export default __exports__